<!--Copyright (c) Laserfiche.
Licensed under the MIT License. See LICENSE in the project root for license information.-->

<div id="add-remove-container" class="add-remove-container">
  <div id="adhoc-back-button" class="back-button-overlay" (click)="onClickBack()">
    <div class="adhoc-back-button-container">
      <span class="material-icons lf-button adhoc-back-button" id="arrow-left-18"> arrow_back_ios_new </span>
    </div>
    <div class="ms-font-m back-button-text">{{ ADD_REMOVE_FIELDS | async }}</div>
  </div>
  <div class="back-button-padding"></div>
  <div class="add-remove-content">
    <ng-container *ngIf="isLoading; else checkIfError">
      <lf-loader-component class="lf-adhoc-state-message"></lf-loader-component>
    </ng-container>
    <ng-template #checkIfError>
      <ng-container *ngIf="shouldShowErrorMessage; else showFieldPicker">
        <div class="lf-adhoc-state-message error-entries-text">{{ AN_ERROR_OCCURED | async }}</div>
      </ng-container>
      <ng-template #showFieldPicker>
        <div class="field-picker-container" [ngClass]="{ 'has-changes': areCheckboxChanges }">
          <div class="search">
            <input
              [value]="fieldFilterText"
              [formControl]="filterFieldsControl"
              placeholder="{{ SEARCH_FIELDS | async }}"
              class="searchBox"
            />
            <div class="icon icon-search"></div>
            <div
              *ngIf="fieldFilterText && fieldFilterText.length > 0"
              (click)="onClearFields()"
              class="icon icon-clear"
            ></div>
          </div>
          <ng-container *ngIf="displayFieldInfos && displayFieldInfos.length > 0; else noField">
            <cdk-virtual-scroll-viewport itemSize="25" class="pick-field">
              <div *cdkVirtualFor="let field of displayFieldInfos; let i = index">
                <mat-checkbox
                  color="primary"
                  class="lf-checkbox"
                  (change)="onUpdateCheckbox($event, field)"
                  id="`add-remove-checkbox-{{ i }}`"
                  [checked]="isFieldSelected(field)"
                  title="{{ field.displayName }}"
                  [disabled]="field.inTemplateSelected"
                >
                  {{ field.displayName }} ({{ field | getFieldType: LOCALIZED_FIELD_TYPES | async }})
                </mat-checkbox>
              </div>
            </cdk-virtual-scroll-viewport>
          </ng-container>
          <ng-template #noField>
            <div class="lf-adhoc-state-message fields-empty">
              {{ NO_MATCHING_FIELDS_FOUND | async }}
            </div>
          </ng-template>
        </div>
      </ng-template>
    </ng-template>
  </div>
  <div class="button-container" *ngIf="areCheckboxChanges">
    <div class="button-padding-container">
      <button id="adhoc-apply-button" class="primary-button lf-button adhoc-field-button" (click)="onClickApply()">
        {{ APPLY | async }}
      </button>
      <button id="adhoc-cancel-button" class="sec-button lf-button adhoc-field-button" (click)="onClickCancel()">
        {{ CANCEL | async }}
      </button>
    </div>
  </div>
</div>

<ng-template #addRemoveConfirmModal let-data>
  <lf-popup-modal-component [data]="data" (buttonClick)="onModalButtonClick($event)"></lf-popup-modal-component>
</ng-template>
